export default {"src":"/_next/static/media/KeepaNewLogoRight.f05b84a4.svg","height":32,"width":131};